import { doc, Timestamp, writeBatch } from 'firebase/firestore';
import { db } from '../../../config';
import { firestoreBatchLimit } from '../../../../../constants/enum';

export interface MasterMappingOrder {
  masterId: string;
  mappingId: string;
  /** パターン内での実行順。0 始まりの連番。 */
  executionOrder: number;
}

/**
 * パターン内の全マッピングの execution_order を一括更新する（#3180）。
 *
 * master_mappings は master 配下のサブコレクションのため、パターン単位の並べ替えは
 * 複数マスタドキュメントにまたがる更新になる。順序が中途半端に適用されると
 * 照合順が壊れるため writeBatch で原子的に行う。
 *
 * 1 コミットあたりのオペレーション数には SDK 制約（firestoreBatchLimit）があるため、
 * 上限を超える場合は分割してコミットする。
 * ※ 分割した場合はコミット単位でしか原子性が保証されない。
 *   1パターンに 500 件のマッピングが付くことは実運用上想定していないが、
 *   上限超過でコミットが丸ごと失敗するよりは分割して進めるほうが安全なためこの方針とする。
 */
export const updateMasterMappingOrders = async (orders: MasterMappingOrder[]): Promise<void> => {
  if (orders.length === 0) return;

  for (let offset = 0; offset < orders.length; offset += firestoreBatchLimit) {
    const chunk = orders.slice(offset, offset + firestoreBatchLimit);
    const batch = writeBatch(db);
    const now = Timestamp.now();

    for (const order of chunk) {
      const mappingRef = doc(db, 'masters', order.masterId, 'master_mappings', order.mappingId);
      batch.update(mappingRef, {
        execution_order: order.executionOrder,
        updated_at: now,
      });
    }

    await batch.commit();
  }
};
